import { ListCheck, Plus } from 'lucide-react'
import { Button } from '../../../components/ui/button'
import { Dialog, DialogContent, DialogTrigger } from '../../../components/ui/dialog'
import { ScrollArea } from '../../../components/ui/scroll-area'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table'
import { Tabs, TabsList, TabsTrigger } from '../../../components/ui/tabs'
import { useCashfitParams } from '../../../hooks/use-params'
import { loadAtributes } from './actions'
import { FormTemplate } from './components/form-template'
import { ListTemplates } from './components/list-templates'

type Tabs = 'add-template' | 'list-templates' | 'add-contract' | 'list-contracts'

export default function ContractPage() {
  const { getParam, setParams, removeParam } = useCashfitParams<Tabs>({
    navId: '14',
    tabSelected: 'add-template',
    page: String(0)
  })
  const tab = getParam('tabSelected')

  const { data: responseEnviroments } = loadAtributes()

  return (
    <main>
      <div className="w-full overflow-y-scrol flex justify-between">
        <Tabs
          defaultValue={getParam('tabSelected') || 'add-template'}
          value={getParam('tabSelected') || 'add-template'}
          className="w-[320px]"
          onClick={() => removeParam('tabContentId')}
          onValueChange={(value) => {
            setParams({
              tabSelected: value as keyof Tabs
            })
          }}
        >
          <TabsList>
            <TabsTrigger value="add-template" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
              <Plus />
              Cadastrar template
            </TabsTrigger>
            <TabsTrigger value="list-templates" className="data-[state=active]:bg-acelerafit-green-400 data-[state=active]:text-muted flex gap-2">
              <ListCheck />
              Lista de templates
            </TabsTrigger>
          </TabsList>
        </Tabs>

        <div className="flex gap-2">
          {tab == 'add-template' && (
            <Dialog>
              <DialogTrigger asChild>
                <Button variant="outline">Palavras Chave</Button>
              </DialogTrigger>
              <DialogContent className="min-w-[1200px]">
                <ScrollArea className="h-[600px] ">
                  <Table className="w-full">
                    <TableHeader>
                      <TableRow>
                        <TableHead className="w-[100px]">Tag</TableHead>
                        <TableHead className="min-w-[750px]">Descrição</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {responseEnviroments &&
                        responseEnviroments.data.data.map((enviroment: { nome: string; descricao: string; identificador: string }) => (
                          <TableRow key={enviroment.identificador}>
                            <TableCell className="font-medium">{enviroment.identificador}</TableCell>
                            <TableCell className="font-medium">{enviroment.descricao}</TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              </DialogContent>
            </Dialog>
          )}

          {/* {tab == 'list-templates' && (
            <Button className="text-muted flex gap-2 text-sm" variant="outline">
              <ListFilter />
              Filtro
            </Button>
          )} */}
        </div>
      </div>

      {tab == 'add-template' && <FormTemplate templateId={getParam('tabContentId')} />}

      {tab == 'list-templates' && (
        <div className="content border-acelerafit-gray-white rounded-md border p-6 mt-4 flex flex-col gap-2">
          <header>
            <h3 className="text-acelerait-black text-2xl font-bold">Templates de contratos</h3>
            <p className="text-sm text-acelerafit-gray-dark">Gerencie e acompanhe o cadastro, status e informações dos templates de contratos.</p>
          </header>
          <ListTemplates page={getParam('page') || '0'} />
        </div>
      )}
    </main>
  )
}
